module.exports = __webpack_public_path__ + "images/pro/statistics@2x-871bcfe3d049ed4fa77b53c0a1b9e86e.png";